import React from 'react';
import PlumbingIcon from '@mui/icons-material/Plumbing';

import ListPage from '../../../sharedModules/listPage/ListPage';
import { backflowJobGroupsColumns } from '../constants/backflowListColumns';

const columns = backflowJobGroupsColumns().filter((col: any) => !['Actions', 'Scheduled', 'Status'].includes(col.name));

const UnscheduledTestsListPage: React.FC = () => {
  return (
    <ListPage
      clickableRows
      columns={columns}
      controller="backflows/backflow_job_groups"
      defaultFilters={{ status_in: ['not_scheduled'] }}
      defaultSort="updated_at asc"
      rowClickPath="backflow_tests/backflow_job_groups"
      title="Unscheduled Tests"
      titleIcon={<PlumbingIcon />}
    />
  );
};

export default UnscheduledTestsListPage;
